
const search = {
  state: {
    upStation: {},
    downStation: {}
  },
  mutations: {
    set_startStation (state, params) {
      state.upStation = params
    },
    set_endStation (state, params) {
      state.downStation = params
    }
  },
  actions: {
    save_startStation ({commit, state}, params) {
      commit('set_startStation', params)
    },
    save_endStation ({commit, state}, params) {
      commit('set_endStation', params)
    }
  }

}
export default search
